const system_limit = {
    limit_exceeded: 'You have reached the system limit. Please contact support for assistance.',
};
export default Object.freeze(system_limit);
